<ng-container *ngIf="view$ | async as view">
  <section class="search-suggestion" *ngIf="view.map as map">
    <div class="search-suggestion__header">
      <h5 class="search-suggestion__title">Có phải bạn muốn tìm: <strong>{{ map.rewriteTo }}</strong>?</h5>
      <a *ngIf="map.total > map.products.length" class="search-suggestion__more" [routerLink]="['/product']"
        [queryParams]="{ searchTerm: map.rewriteTo }">Xem tất cả ({{ map.total }})</a>
    </div>
    <div class="product-grid">
      <app-product-box *ngFor="let product of map.products; trackBy: trackByProduct" [product]="product"
        [isListView]="isListView" [style]="'horizontal'"></app-product-box>
    </div>
  </section>

  <section class="search-suggestion" *ngIf="view.equivalent as equivalent">
    <div class="search-suggestion__header">
      <h5 class="search-suggestion__title">GiaThuocTot gợi ý</h5>
    </div>
    <div class="product-grid">
      <app-product-box *ngFor="let product of equivalent.products; trackBy: trackByProduct" [product]="product"
        [isListView]="isListView" [style]="'horizontal'"></app-product-box>
    </div>
  </section>
</ng-container>
